exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{min-height:100vh;overflow:auto;background:#16161f}", ""]);

// exports
